import { motion } from "framer-motion";
import { EASE } from "./data";

export const Reveal = ({ children, delay = 0, y = 32, className = "", as = "div" }) => {
  const Comp = motion[as];
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </Comp>
  );
};

export const Eyebrow = ({ children, light = false }) => (
  <div className={`inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.22em] ${light ? "text-white/80" : "text-[var(--muted)]"}`}>
    <span className="flex h-[10px] w-6 flex-col overflow-hidden rounded-[2px]">
      <span className="flex-1 bg-[#CE2939]" /><span className="flex-1 bg-white ring-1 ring-black/5" /><span className="flex-1 bg-[#477050]" />
    </span>
    {children}
  </div>
);
